import { Amplify } from 'aws-amplify';
import {
  Authenticator,
  ThemeProvider,
  useTheme,
  Heading,
} from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { LoggedInApp } from './components/LoggedInApp';
import { theme } from './theme';
import './index.css';

import awsExports from './aws-exports';
Amplify.configure(awsExports);

// 1. Create a custom components object
const components = {
  // This will override the default Header
  Header() {
    const { tokens } = useTheme();

    return (
      <div
        style={{
          textAlign: 'center',
          padding: `${tokens.space.large.value} 0`,
        }}
      >
        <img
          alt='Aslan logo'
          src='https://backoffice.aslan.io/assets/fullLogoWhite-786d83d1.svg'
          style={{
            height: '60px',
            padding: '10px',
            backgroundColor: '#392080', // Dark purple background for the white logo
            borderRadius: '8px',
            marginBottom: '10px',
          }}
        />
        <Heading level={3} style={{ color: '#392080' }}>
          Client File Manager
        </Heading>
      </div>
    );
  },
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      {/* 2. Pass the custom components object to the Authenticator */}
      <Authenticator hideSignUp={true} components={components}>
        <LoggedInApp />
      </Authenticator>
    </ThemeProvider>
  );
}

export default App;
